export default {
  "Update case success": "Кейс успешно обновлен",
  ru: "RU",
  en: "EN",
  languages: {
    ru: "Русский",
    en: "Английский",
    ar: "Арабский",
    es: "Испанский",
    fa: "Персидский",
    kz: "Казахский",
    pt: "Португальский",
    fr: "Французский",
  },
  CoursesTitle: "Курсы | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "Искусственный интеллект",
    desc: "Анализ медицинских изображений с помощью ИИ-сервисов",
  },
  Module_edu: {
    title: "Образование",
    desc: "Тренажеры насмотренности, курсы и полезные материалы для врачей",
  },
  Module_community: {
    title: "Сообщество",
    desc: "Обмен знаниями между врачами, обсуждение клинических случаев",
  },
  Profile: "Профиль",
  Subscription: "Подписка",
  "Go to site": "Перейти на сайт",
  "Access after pay": "Урок ещё не открыт",
  Exit: "Выйти",
  MY: "ЛК",
  Home: "Главная",
  "Mobile banner text : demo":
    "Создайте аккаунт и получите полный доступ к ИИ сервисам и тренажерам",
  Platform: "ПЛАТФОРМА ДЛЯ ВРАЧЕЙ",
  "Platform info":
    "ИИ помощники, тренажеры насмотренности, курсы и полезные материалы для врачей",
  "Download app": "Скачать приложение",
  "Home title":
    "Платформа для врачей | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "ИИ-сервисы",
  edu: "Образование",
  community: "Сообщество врачей",
  "Your courses": "Ваши курсы",
  "Recomended courses": "Рекомендуемые курсы",
  Courses: "Курсы",
  Calculator: "Калькулятор",
  Plug: "Подключить",
  "Go to": "Перейти",
  Case: "Задание",
  Cases: "Задания",
  "Case success": "Выполнено",
  "Case unsuccess": "Не выполнено",
  Modality: "Модальность",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "Не нашли нужный сервис?",
  "Text us": "Напишите об этом",
  "I need AI for...": "Я хочу ИИ-сервис для ...",
  "Thx for reply": "Спасибо за предложение!",
  Send: "Отправить",
  Sent: "Отправлено",
  "Cannot loading reply -- adblock":
    "Не удалось отправить. Пожалуйста, отключите расширения браузера, такие, как VPN и блокировщики рекламы",
  Favorites: "Избранное",
  "Cases about 1": "Добавьте свой кейс",
  "Cases about 2":
    "Обсуждайте интересные кейсы, задавайте вопросы, обменивайтесь опытом! Добавьте кейс, все исследования",
  "Cases about 3": "анонимизируются",
  "Add case": "Добавить кейс",
  All: "Все",
  "I upload": "Загруженные",
  drafts: "Черновики",
  draft: "Черновик",
  "Case v2": "Кейс",
  "Open study": "Открыть исследование",
  Comments: "Комментарии",
  "Comment placeholder": "Написать комментарий...",
  "Favorites about 1": "Здесь пока нет ничего нет, нажмите на иконку",
  "Favorites about 2": "у интересного кейса, чтобы добавить его в избранное",
  "Comment screen info 1": "Чтобы приложить скриншот, ",
  "Comment screen info 2": "откройте исследование в просмотровщике",
  Download: "Скачать",
  "Record Date": "Запись лекции",
  "Request a course": "Записаться",
  "Request a course doned": "Вы оставили заявку на курс",
  "Forgot password?": "Забыли пароль?",
  "Reset password": "Восстановление пароля",
  "Reset password v2": "Восстановить пароль",
  "Reset password about":
    "Укажите адрес электронной почты, который вы использовали при регистрации. Мы вышлем вам инструкцию по восстановлению пароля",
  "Reset password about after":
    "Ссылка для восстановления пароля отправлена на почту",
  "Back to prev page": "Вернуться назад",
  Email: "Электронная почта",
  "Not valid email": "Неверный формат электронной почты",
  EmailAlreadyRegistered: "Адрес электронной почты уже используется",
  NotActivatedAccount:
    "The user exists, but their account has not yet been activated.",
  "Not found email": "Электронная почта не зарегистрирована",
  "Back to login": "Вернуться к входу",
  "Email not come?": "Не пришло письмо?",
  "Write to support": "Написать в поддержку",
  "Create new password": "Создайте новый пароль",
  "Password confirm": "Подтверждение пароля",
  "Min 8": "Минимум 8 символов",
  "Two inputs don't match!": "Пароли не совпадают",
  "Update password": "Обновить пароль",
  "Password updated": "Пароль обновлен",
  "Invalid password token": "Ссылка недействительна попробуйте снова",
  "Unknown user": "Неизвестный пользователь",
  "Attach image": "Прикрепите изображение",
  Remove: "Удалить",
  Complain: "Пожаловаться",
  "Complain sent": "Ваша жалоба успешно отправлена",
  owner: "Автор кейса",
  assistant: "Куратор",
  "Answers 1": "ответ",
  "Answers 2": "ответа",
  "Answers 3": "ответов",
  "Add answer": "Ответить",
  "Collapse answers": "Свернуть",
  "Image only": "<Изображение>",
  "Cannot upload from mobile":
    "Вы можете загрузить исследования в формате DICOM с компьютера",
  "Password rule": "Введите минимум 8 символов, 1 латинскую букву и 1 цифру",
  ReferenceCursors: "C - 3D курсор",
  "bad browser for mpr":
    "MPR (может быть недоступен) Рекомендуем открыть сайт в браузере Google Chrome последней версии",
  "Service in process": "Загрузка временно недоступна",
  "Service in process about":
    "Но вы можете изучить функционал сервиса на примере демонстрационных исследований. Мы сообщим вам, когда появится возможность обработать свои исследования.",
  "Edit case": "Редактировать кейс",
  Title: "Заголовок",
  "Access count": "Доступно",
  "Access count about":
    "Если выбрать опцию «Доступно всем», публикация будет видна всем. В случае доступа по ссылке, увидеть её можно только перейдя по прямой ссылке с кнопки «Поделиться».",
  "To All": "Всем",
  "To Link": "По ссылке",
  Publish: "Опубликовать",
  "Publish about":
    "При анонимной публикации ваше имя и компания не будут видны другим пользователям.",
  How: "Как",
  "As Anon": "Анонимно",
  "Case accept": "Я не размещаю никакие персональные данные пациента. ",
  "User Policy": "Политика конфиденциальности",
  "Remove case": "Удалить кейс",
  "Save draft": "Сохранить черновик",
  "Remove case success": "Кейс успешно удален",
  "Remove case error": "Не удалось удалить кейс. Попробуйте позже",
  "Update case error": "Не удалось обновить кейс. Попробуйте позже",
  Edit: "Редактировать",
  "Cases v2": "Кейсы",
  sec: " сек",
  "Confirm accept": "Подтвердите согласие",
  "Remove case?": "Удалить серию?",
  "Upload AI": "Загрузите исследование в формате DICOM",
  "Upload edu": "Загрузите кейс в формате DICOM, JPEG или PNG",
  "Upload community": "Загрузите кейс в формате DICOM, JPEG или PNG",
  "As anon": "Анонимно",
  status: {
    free: "Бесплатно",
    subscription: "По подписке",
    draft: "Черновик",
    archived: "Архив",
    completed: "Пройдено",
  },
  courseType: {
    course: "Курс",
    simulator: "Тренажер",
    webinar: "Вебинар",
  },
  noAcceptResult: "Опишите, с чем вы не согласны",
  Meta: {
    tail: "%s | !" + process.env.VUE_APP_INSTALLATION + "!",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: process.env.VUE_APP_DEFAULT_TITLE,
      desc: process.env.VUE_APP_INSTALL_DESC,
    },

    "community-cases": {
      title: "Медицинское сообщество",
      desc: "Профессиональное интернет-сообщество врачей - обсуждение интересных кейсов, вопросов и обмена опытом!",
    },
    home: {
      title: "Платформа для врачей",
      desc: "Онлайн медицинская платформа: ИИ помощники, тренажеры насмотренности, курсы и полезные материалы для врачей",
    },
    "ai-services": {
      title: "ИИ Сервисы",
      desc: "Сервисы искусственного интеллекта для диагностики заболеваний",
    },
    "edu-services": {
      title: "Образовательная платформа для врачей",
      desc: "Список обучающих курсов и база знаний для врачей диагностов.",
    },
  },
  "Video is unavailable": "Видео недоступно",
  Licence:
    '© 2026 Общество с ограниченной ответственностью "Платформа ' +
    process.env.VUE_APP_INSTALL_NAME +
    '", ИНН 7714420229, ОГРН 5177746328106, все права защищены. 121205, г. Москва, Территория Инновационного центра Сколково, ул. Нобеля д. 7, этаж 2, пом. 37, раб. 2',
  "Policy v2": "Политика обработки и защиты персональных данных",
  "Site company": "Cайт компании",
  homepage: {
    connect: "Подключить за ",
    cost: " / мес",
    goToAI: "Обработать исследования",
    notAuthSub__off: {
      title: "Откройте все возможности ИИ-помощника",
      desc: "Получите доступ к  ИИ-помощнику для автоматизации измерений и составления заключений",
    },
    notAuthSub__on: {
      title: "ИИ-сервисы для анализа медицинских изображений",
      desc: "Автоматизируют измерения и выдают протокол исследования. Обработайте 3 исследования бесплатно, затем — больше за <PRICE>",
    },
    baseSub: {
      title: "Избавьтесь от рутины при анализе исследований с ИИ",
      desc: "ИИ-помощник автоматизирует измерения и составит заключение в 1 клик",
    },
    notBaseSub: {
      title: "Загрузите снимок в 1 клик",
      desc: "Воспользуйтесь ИИ-помощником для автоматизации измерений и составления заключений",
    },
  },
  "Start type": "Начните вводить...",
  buy: "Купить",
  more_details: "Подробнее",
};
